// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1231":"ff28d060","6350":"72a30a16","6925":"2c386607"}[chunkId] || chunkId) + "." + {"599":"5b41f701a53ee996","636":"b7594193061ecd78","1231":"246883cde2f0bbbd","6350":"1084d84c61beea9c","6925":"8c5c7d8ba6bba570","7856":"fc4ac6688983fb4e"}[chunkId] + ".js";
};